/* eslint-disable */
/** Brazilian Portuguese UI strings (former pt-BR locale). */
export const ptBrMessages: Record<string, string> = {
  '404-heading': 'Código de erro: 404',
  '404-sub-heading': 'Ops! Parece que esta página não existe',
  '404-back-home': 'Leve-me para casa',
  'nav-menu-track-order': 'Rastrear Pedido',
  'nav-menu-offer': 'Ofertas',
  'nav-menu-faq': 'FAQ',
  'nav-menu-contact': 'Contato',
  'nav-menu-terms': 'Termos e Condições',
  'nav-menu-flash-sale': 'Promoção Relâmpago',
  'nav-menu-refund-policy': 'Política de Reembolso do Cliente',
  'nav-menu-vendor-refund-policy': 'Política de Reembolso do Vendedor',
  'user-avatar': 'avatar do usuário',
  'auth-menu-profile': 'Perfil',
  'auth-menu-checkout': 'Finalizar Compra',
  'auth-menu-my-orders': 'Meus Pedidos',
  'auth-menu-logout': 'Sair',
  'join-button': 'Login',
  'change-locale': 'Mudar para alemão',
  'text-search': 'Pesquisar',
  'text-burger-menu': 'Menu de Hambúrguer',
  'text-close': 'fechar',
  'text-or': 'OU',
  'text-terms': 'termos',
  'text-policy': 'política',
  'text-accept': 'Aceitar',
  'cookie-message':
    'Este site usa cookies para melhorar sua experiência. Ao clicar, você concorda com nossa',
  'text-privacy-policy': 'política de privacidade',
  'text-minus': 'menos',
  'text-plus': 'mais',
  'text-copy': 'Copiar',
  'text-copied': 'Copiado!',
  'text-expired': 'Expirado',
  'text-expired-at': 'Expirado em',
  'text-card-number': 'Número do Cartão',
  'text-read-more': 'Leia mais',
  'text-less': 'Menos',
  'text-item': 'Item',
  'text-add': 'Adicionar',
  'text-cart': 'Carrinho',
  'text-add-cart': 'Adicionar ao Carrinho de Compras',
  'text-pieces-available': 'peças disponíveis',
  'text-details': 'Detalhes',
  'text-order': 'Pedido',
  'text-recharge': 'Recarga',
  'text-checkout': 'Finalizar Compra',
  'text-website': 'Site',
  'text-apply': 'Aplicar',
  'text-date': 'Data',
  'text-order-date': 'Data do Pedido',
  'text-order-details': 'Detalhes do Pedido',
  'text-payment-method': 'Método de Pagamento',
  'text-address': 'Endereço',
  'text-addresses': 'Endereços',
  'text-upload-highlight': 'Carregar uma imagem',
  'text-upload-message': 'ou arraste e solte',
  'text-img-format': 'PNG, JPG',
  'text-shipping-address': 'Endereço de Envio',
  'text-estimated-shipping': 'Envio Estimado',
  'text-calculated-checkout': 'Calculado no checkout',
  'text-proceed-checkout': 'Continuar para o checkout',
  'text-shipping': 'Envio',
  'text-billing': 'Cobrança',
  'text-billing-address': 'Endereço de Cobrança',
  'text-sub-total': 'Subtotal',
  'text-discount': 'Desconto',
  'text-delivery-fee': 'Taxa de Entrega',
  'text-deliver-time': 'Tempo de Entrega',
  'text-shipping-charge': 'Taxa de Envio',
  'text-free-shipping': 'Frete Grátis',
  'text-free': 'Grátis',
  'text-tax': 'Imposto',
  'text-amount': 'Valor',
  'text-total-price': 'Preço Total',
  'text-added-value': 'Valor Adicionado',
  'text-total-item': 'Total de Itens',
  'text-total-amount': 'Valor Total',
  'text-total': 'Valor Total',
  'text-out-stock': 'Fora de Estoque',
  'text-product-image': 'Imagem do Produto',
  'text-select': 'Selecione o Motivo',
  'select-refund-reason': 'Por favor, selecione seu motivo',
  'text-by': 'por',
  'text-load-more': 'Carregar Mais',
  'text-categories': 'Categorias',
  'text-category': 'Categoria',
  'text-delivery-schedule': 'Cronograma de Entrega',
  'text-home': 'Início',
  'text-user': 'Usuário',
  'text-edit': 'Editar',
  'text-type': 'Tipo',
  'text-title': 'Título',
  'text-country': 'País',
  'text-city': 'Cidade',
  'text-state': 'Estado',
  'text-zip': 'CEP',
  'text-county': 'Bairro',
  'text-number': 'Número da residência',
  'text-complement': 'Complemento',
  'text-observation': 'Observação',
  'text-street-address': 'Endereço',
  'text-add-new': 'Adicionar Novo',
  'profile-sidebar-friends-indication': 'Indique amigos',
  'profile-sidebar-profile': 'Perfil',
  'profile-sidebar-password': 'Alterar Senha',
  'profile-sidebar-orders': 'Meus Pedidos',
  'profile-sidebar-addresses': 'Endereços',
  'profile-sidebar-help': 'Precisa de Ajuda',
  'profile-sidebar-logout': 'Sair',
  'password-successful': 'Senha alterada com sucesso',
  'error-enough-permission': 'Não possui permissão suficiente',
  'error-credential-wrong': 'As credenciais estão incorretas!',
  'error-needs-password-setup': 'Encontramos seu cadastro!',
  'error-needs-password-setup-detail':
    'Para acessar nossa nova plataforma, você precisa criar uma senha. Enviamos um link de redefinição de senha para o seu e-mail.',
  'resend-setup-email': 'Reenviar e-mail de redefinição de senha',
  'register-email-exists-title': 'Você já tem uma conta conosco!',
  'register-email-exists-detail':
    'O e-mail informado já está cadastrado em nossa plataforma. Entre com sua conta ou redefina sua senha.',
  'go-to-login': 'Entrar na minha conta',
  'go-to-forgot-password': 'Esqueci minha senha',
  'login-helper': 'Faça login com seu e-mail e senha',
  'error-email-format': 'E-mail inválido',
  'error-email-required': 'E-mail obrigatório',
  'error-password-required': 'Você precisa fornecer sua senha',
  'error-subject-required': 'Qual assunto você deseja discutir conosco?',
  'error-description-required': 'Conte-nos mais sobre isso',
  'error-select-required': 'Selecione seu motivo',
  'text-login': 'Entrar',
  'text-no-account': 'Não tem uma conta?',
  'text-already-account': 'Já tem uma conta?',
  'text-register': 'Cadastrar',
  'text-old-password': 'Senha Antiga',
  'text-new-password': 'Nova Senha',
  'text-confirm-password': 'Confirmar Senha',
  'error-old-password-required': 'Senha antiga é obrigatória!',
  'error-new-password-required': 'Senha é obrigatória!',
  'error-confirm-password': 'Por favor, confirme a senha!',
  'error-match-passwords': 'As senhas devem coincidir!',
  'registration-helper': 'Ao se inscrever, você concorda com nossos',
  'error-name-required': 'Você precisa fornecer seu nome',
  'error-last-name-required': 'Você precisa fornecer seu sobrenome',
  'error-phone-required': 'Você precisa fornecer seu telefone',
  'error-phone-incomplete':
    'Por favor, preencha o celular ou complete o número (incluindo DDD quando for o caso)',
  'error-cpf-required': 'Você precisa fornecer seu CPF',
  'error-gender-required': 'Você precisa fornecer seu genêro',
  'forgot-password-helper': 'Enviaremos um link para o endereço digitado',
  'error-token-required': 'Você precisa fornecer seu token',
  'token-label': 'Insira o token que você recebeu por e-mail',
  'text-reset-password': 'Redefinir Senha',
  'text-back': 'Voltar',
  'text-back-to': 'Voltar para',
  'text-back-to-home': 'Voltar para a Início',
  'text-forgot-password': 'Esqueci a senha',
  'text-visit-site': 'Visitar Este Site',
  'text-follow-us': 'Siga-nos',
  'text-questions-comments': 'Como podemos melhorar sua experiência?',
  'text-vendor-comments': 'Estamos sempre aqui para você',
  'text-vendor-comments-subtitle':
    'vai receber um e-mail. Adoraríamos ouvir de você.',
  'text-vendor-refund-title': 'Política de Reembolso do Vendedor',
  'text-customer-refund-title': 'Política de Reembolso do Cliente',
  'text-faq-title': 'Perguntas Frequentes',
  'text-name': 'Nome',
  'text-last-name': 'Sobrenome',
  'text-social-name': 'Nome social',
  'text-cellphone': 'Celular com DDD',
  'text-cellphone-ddd': 'Celular com DDD',
  'text-phone': 'Telefone',
  'text-phone-ddd': 'Telefone com DDD',
  'text-cpf': 'CPF',
  'text-password': 'Senha',
  'text-repeat-password': 'Repetir senha',
  'text-email': 'E-mail',
  'text-birth-date': 'Data de nascimento',
  'text-subject': 'Assunto',
  'text-description': 'Descrição',
  'text-contact-number': 'Número de Contato',
  'text-save': 'Salvar',
  'text-update': 'Atualizar',
  'text-submit-email': 'Enviar E-mail',
  'text-submit-token': 'Enviar Token',
  'text-loading': 'Carregando...',
  'text-signing-out': 'Saindo...',
  'error-something-wrong': 'Algo deu errado',
  'text-no-result-found': 'Nenhum Resultado Encontrado',
  'text-not-found': 'Desculpe, Nenhum Produto Encontrado :(',
  'text-no-category': 'Desculpe, Nenhuma Categoria Encontrada :(',
  'text-no-faq': 'Desculpe, Nenhuma Pergunta Frequente Encontrada :(',
  'text-no-manufacturers': 'Desculpe, Nenhum Fabricante Encontrado :(',
  'text-no-refund-policy':
    'Desculpe, Nenhuma Política de Reembolso Encontrada :(',
  'text-no-terms': 'Desculpe, Nenhum Termo e Condição Encontrado :(',
  'text-no-refund': 'Desculpe, Nenhuma Política de Reembolso Encontrada :(',
  'text-no-coupon': 'Desculpe, Nenhum Cupom Encontrado :(',
  'text-no-flash-deal': 'Nenhuma promoção relâmpago encontrada. :(',
  'text-related-products': 'Produtos Relacionados',
  'text-previous': 'Anterior',
  'text-next': 'Próximo',
  'text-unavailable': 'Indisponível',
  'text-remove-card': 'Remover cartão',
  'text-remove-card-message': 'Tem certeza de que deseja excluir este cartão?',
  'text-cancel': 'cancelar',
  'text-delete': 'Excluir',
  'text-filter': 'Filtrar',
  'text-stripe': 'Stripe',
  'text-place-order': 'Finalizar Compra',
  'text-your-order': 'Seu Pedido',
  'text-cash-on-delivery': 'Pagamento na Entrega',
  'text-card-info': 'Informações do Cartão',
  'text-no-products': 'Nenhum produto encontrado',
  'text-search-label': 'pesquisa de mantimentos no cabeçalho',
  'text-search-placeholder': 'Pesquise seus produtos aqui',
  'text-search-placeholder-minimal': 'Pesquisar na qualidoc',
  'text-no-address': 'Nenhum Endereço Encontrado',
  'text-have-coupon': 'Você tem um cupom?',
  'text-enter-coupon': 'Digite o código do cupom aqui',
  'text-coupon-required': 'Código do cupom é obrigatório',
  'text-enter-contact-number': 'Digite seu Número de Contato',
  'text-payment-gateway': 'Gateway de Pagamento',
  'text-order-received': 'Pedido Recebido',
  'text-thank-you': 'Obrigado!',
  'text-order-number': 'Número do Pedido',
  'placeholder-card-number': 'Número do Cartão (ex: 4242424242424242)',
  'placeholder-m-y': 'M/A',
  'placeholder-cvc': 'CVC',
  'error-card-required': 'O número do cartão é obrigatório',
  'error-expiry-date': 'A data de validade é obrigatória',
  'error-cvc': 'O CVC é obrigatório',
  'error-contact-required': 'O número de contato é obrigatório',
  'error-invalid-coupon':
    'Código de cupom inválido! Por favor, tente novamente.',
  'error-minimum-amount-satisfy':
    'Desculpe, este cupom não é aplicável. Faça um pedido acima de',
  'error-type-required': 'O tipo é obrigatório',
  'error-title-required': 'O título é obrigatório',
  'error-country-required': 'O país é obrigatório',
  'error-city-required': 'A cidade é obrigatória',
  'error-state-required': 'O estado é obrigatório',
  'error-county-required': 'O bairro é obrigatório',
  'error-number-required': 'O número é obrigatório',
  'error-zip-required': 'O CEP é obrigatório',
  'error-street-required': 'O endereço é obrigatório',
  'error-order-unavailable': 'Os itens do seu pedido estão indisponíveis',
  'error-cant-process-order': 'Desculpe, não podemos processar seu pedido :(',
  'error-add-both-address':
    'Por favor, adicione tanto o endereço de entrega quanto o de faturamento',
  'error-cart-empty': 'Seu carrinho está vazio. Vá para',
  'error-no-orders': 'Você ainda não fez nenhum pedido',
  'change-password': 'Alterar Senha',
  'text-submit': 'Enviar',
  'text-bio': 'Biografia',
  'profile-update-successful': 'Perfil atualizado com sucesso',
  'text-no-contact': 'Nenhum contato encontrado',
  'text-view-sub-orders': 'Ver subpedidos',
  'text-shops-near-you': 'Lojas Perto de Você',
  'text-sellers': 'Vendedores',
  'text-sub-orders': 'Detalhes',
  'text-new': 'Novo',
  'text-all-shops': 'Todas as Lojas',
  'text-near-shops': 'Lojas Próximas',
  'text-tracking-number': 'Número de Rastreamento',
  'text-status': 'Status',
  'text-quantity': 'Quantidade',
  'text-view': 'Ver',
  'text-logo': 'Logo',
  NOT_FOUND: 'Não Encontrado',
  'nav-menu-shops': 'Lojas',
  'text-login-facebook': 'Entrar com Facebook',
  'text-login-google': 'Entrar com Google',
  'text-note': 'Nota',
  'text-purchase-note': 'Nota de Compra',
  CASH_ON_DELIVERY: 'Pagamento na Entrega',
  'message-sub-order':
    'Este pedido contém produtos de vários vendedores. Portanto, dividimos este pedido em várias ordens de vendedores.',
  'error-min-contact': 'O número de contato deve ter pelo menos 8 dígitos',
  'PICKBAZAR_ERROR.NOT_FOUND': 'Não Encontrado',
  'PICKBAZAR_ERROR.NOT_AUTHORIZED': 'Não Autorizado',
  'PICKBAZAR_ERROR.INVALID_CREDENTIALS': 'Credenciais Inválidas',
  'PICKBAZAR_ERROR.SOMETHING_WENT_WRONG': 'Algo deu errado',
  'PICKBAZAR_ERROR.PAYMENT_FAILED': 'Falha no Pagamento',
  'PICKBAZAR_ERROR.OPERATION_NOT': 'Operação Não',
  'PICKBAZAR_ERROR.INSUFFICIENT_BALANCE': 'Saldo Insuficiente',
  'PICKBAZAR_ERROR.WITHDRAW_MUST_BE_ATTACHED_TO_SHOP':
    'O saque deve estar vinculado a uma loja',
  'PICKBAZAR_ERROR.PLEASE_LOGIN_USING_FACEBOOK_OR_GOOGLE':
    'Por favor, faça login usando Facebook ou Google',
  'PICKBAZAR_ERROR.ACTION_NOT_VALID': 'Ação não válida',
  'PICKBAZAR_ERROR.SHOP_NOT_APPROVED': 'Loja não aprovada',
  'PICKBAZAR_ERROR.THIS_COUPON_CODE_IS_ONLY_FOR_VERIFIED_USERS':
    'Este código de cupom é apenas para usuários verificados',
  'PICKBAZAR_ERROR.THIS_COUPON_CODE_IS_NOT_APPROVED':
    'Código de cupom inválido! Por favor, tente novamente.',
  'PICKBAZAR_ERROR.COUPON_CODE_IS_NOT_APPLICABLE_IN_THIS_SHOP_PRODUCT':
    'O valor dos produtos não atende a este cupom específico da loja.',
  'PICKBAZAR_MESSAGE.NOT_FOUND': 'Não Encontrado',
  'PICKBAZAR_MESSAGE.CHECK_INBOX_FOR_PASSWORD_RESET_EMAIL':
    'Verifique a caixa de entrada para o e-mail de redefinição de senha',
  'PICKBAZAR_MESSAGE.SOMETHING_WENT_WRONG': 'Algo deu errado',
  'PICKBAZAR_MESSAGE.TOKEN_IS_VALID': 'O token é válido',
  'PICKBAZAR_MESSAGE.INVALID_TOKEN': 'O token não é válido',
  'PICKBAZAR_MESSAGE.PASSWORD_RESET_SUCCESSFUL':
    'Redefinição de senha bem-sucedida',
  'PICKBAZAR_MESSAGE.INVALID_CREDENTIALS':
    'As credenciais fornecidas não são válidas',
  'PICKBAZAR_MESSAGE.EMAIL_SENT_SUCCESSFUL': 'E-mail enviado com sucesso',
  'PICKBAZAR_ERROR.YOU_HAVE_ALREADY_GIVEN_ABUSIVE_REPORT_FOR_THIS':
    'Você já enviou uma denúncia',
  'PICKBAZAR_ERROR.MAXIMUM_QUESTION_LIMIT_EXCEEDED':
    'Limite máximo de perguntas excedido',
  'text-more-info': 'Mais Informações',
  'text-price': 'Preço',
  'text-no-order-found': 'Desculpe, Nenhum Pedido Encontrado :(',
  'text-choose-payment': 'Escolha o Método de Pagamento',
  'text-cod-message': 'Por favor, pague após receber seus produtos!',
  'text-login-mobile': 'Entrar com número de celular',
  'text-send-otp': 'Enviar OTP',
  'text-otp-code': 'Código OTP',
  'text-verify-code': 'Verificar Código',
  'text-otp-send-failed': 'Falha ao enviar o código OTP',
  'text-otp-verify-failed': 'Falha na verificação do OTP',
  'contact-update-successful': 'Número de telefone atualizado com sucesso!',
  'text-change-phone-number': 'Alterar número de telefone',
  'add-phone-number': 'Adicionar número de telefone',
  'text-confirm': 'Confirmar',
  'text-check-availability': 'Verificar Disponibilidade',
  'text-no-delivery-time-found': 'Nenhum horário de entrega encontrado',
  'otp-login-helper':
    'Entre com seu número de celular. Enviaremos um código para o número fornecido para acessar sua conta',
  'button-cancel': 'Cancelar',
  'button-delete': 'Excluir',
  'delete-item-confirm': 'Tem certeza de que deseja excluir?',
  'PICKBAZAR_ERROR.OTP_VERIFICATION_FAILED': 'Falha na Verificação',
  'PICKBAZAR_ERROR.OTP_SEND_SUCCESSFUL': 'Verificação Bem-sucedida',
  'PICKBAZAR_ERROR.OTP_SEND_FAIL': 'Não foi possível enviar o OTP',
  'text-see-more': 'Ver mais',
  'text-no-shops': 'Desculpe, Nenhuma Loja Encontrada :(',
  'text-view-more': 'Ver Mais',
  'text-all-categories': 'Todas as Categorias',
  'text-wallet': 'Carteira',
  'text-balance': 'saldo',
  'text-currency': 'moeda',
  'text-payable': 'A Pagar',
  'text-wallet-use': 'Você quer usar a carteira?',
  'text-total-points': 'Total de pontos',
  'text-points-used': 'Pontos usados',
  'text-available-points': 'Pontos disponíveis',
  'text-points': 'Pontos',
  'text-pending': 'Pendente',
  'text-approved': 'Aprovado',
  'text-rejected': 'Rejeitado',
  'text-processing': 'Processando',
  'text-my-refunds': 'Meus Reembolsos',
  'text-refund': 'Reembolso',
  'text-shop': 'Loja',
  'text-ask-refund': 'Solicitar reembolso',
  'text-ask-refund-details':
    'Tem certeza de que deseja solicitar um reembolso?',
  'text-yes': 'Sim',
  'text-no': 'Não',
  'text-view-order': 'Ver Pedido',
  'text-refund-request-submitted': 'Pedido de reembolso enviado',
  'text-reason': 'Motivo do Reembolso',
  'text-id': 'ID',
  'text-paid-from-wallet': 'Pago com a Carteira',
  'text-copyright': 'Copyright',
  'text-rights-reserved': 'Todos os direitos reservados',
  'text-sending': 'Enviando',
  'text-enter-email': 'Digite seu e-mail',
  'text-enter-name': 'Digite seu nome',
  'text-cta-header': 'O App Pickbazar',
  'text-cta-description':
    'Facilite sua loja online com nosso <span class="font-bold">aplicativo móvel</span>',
  'text-showing': 'Mostrando',
  'text-of': 'de',
  'text-products': 'produtos',
  'text-sort': 'Ordenar',
  'text-sort-by-price': 'Ordenar Por Preço',
  'text-sort-relevance': 'Relevância',
  'text-sort-best-promotion': 'Melhores promoções',
  'text-sort-price-asc': 'Menor preço',
  'text-sort-price-desc': 'Maior preço',
  'text-sort-by-author': 'Ordenar Por Autor',
  'text-sort-by-language': 'Ordenar Por Idioma',
  'text-sort-by-format': 'Ordenar Por Formato',
  'text-clear-all': 'Limpar Tudo',
  'text-view-all': 'Ver Todos',
  'text-see-all': 'Ver Todos',
  'text-no-authors': 'Desculpe, Nenhum Autor Encontrado :(',
  'text-search-authors-title': 'Pesquise Nossos Autores Queridos',
  'text-search-authors-subtitle':
    'Lorem ipsum dolor sit amet, consectetu eradipiscing elit.',
  'text-explore-more': 'Explorar Mais',
  'text-born': 'Nascido',
  'text-died': 'Falecido',
  'text-languages': 'Idiomas',
  'text-author-books': 'Livros do Autor',
  'text-books': 'Livros',
  'text-buy-now': 'Comprar Agora',
  'text-buy-again': 'Comprar novamente',
  'text-buy-again-adding': 'Adicionando...',
  'text-buy-again-success': 'produto(s) adicionado(s) ao carrinho',
  'text-buy-again-partial':
    'Produto(s) adicionado(s) parcialmente (estoque limitado)',
  'text-buy-again-out-of-stock': 'Produto(s) sem estoque',
  'text-buy-again-none-available': 'Nenhum produto disponível em estoque',
  'text-buy-again-error': 'Erro ao adicionar produtos ao carrinho',
  'text-formats': 'Formatos',
  'text-sku': 'SKU',
  'text-author': 'Autor',
  'text-authors': 'Autores',
  'text-publisher': 'Editora',
  'text-manufacturers': 'Fabricantes/Editores',
  'text-edition': 'Edição',
  'text-language': 'Idioma',
  'text-become-seller': 'Torne-se um Vendedor',
  'text-search-author': 'Pesquise seu autor favorito aqui',
  'text-search-manufacturer': 'Pesquise fabricantes/editora aqui',
  'text-search-manufacturers-title': 'Fabricantes/Editores',
  'text-search-manufacturers-subtitle':
    'Lorem ipsum dolor sit amet, consectetu eradipiscing elit.',
  'text-tags': 'Tags',
  'text-popular-products': 'Produtos Populares',
  'text-new-arrival': 'Novos Livros Chegados',
  'text-by-author': 'Por (autor)',
  'profile-sidebar-downloads': 'Downloads',
  'text-downloads': 'Downloads',
  'text-download': 'Baixar',
  'text-selling-books': 'Livros Mais Vendidos do Mês Passado',
  'text-purchased-on': 'Comprado em',
  'text-key': 'Chave',
  'text-add-to-cart': 'Adicionar ao Carrinho',
  'text-used': 'Usado',
  'text-available': 'Disponível',
  'text-wallet-points': 'Pontos de Carteira',
  'text-off': 'Desconto',
  'text-no-download':
    'Desculpe, você ainda não comprou nenhum produto para download.',
  'text-subscribe-successfully':
    'Parabéns! Você se inscreveu com sucesso em nossa newsletter.',
  'text-which-book': 'Qual Livro Você Gostaria de Ver?',
  'text-top-authors': 'Principais Autores',
  'text-subscribe-now': 'Cadastre-se para receber todas as novidades',
  'text-subscribe-now-button': 'Receber novidades',
  'text-subscribe-details':
    'Inscreva seu e-mail para receber nossa newsletter e notícias destacadas com base no seu interesse',
  'text-explore': 'Explorar',
  'text-about-us': 'Sobre Nós',
  'text-sitemap': 'Mapa do Site',
  'text-bookmarks': 'Favoritos',
  'text-sign-join': 'Entrar/Cadastrar-se',
  'text-customer-service': 'Atendimento ao Cliente',
  'text-faq-help': 'FAQ & Ajuda',
  'text-returns': 'Devoluções',
  'text-accessibility': 'Acessibilidade',
  'text-contact-us': 'Fale Conosco',
  'text-store-pickup': 'Retirada na Loja',
  'text-our-information': 'Nossas Informações',
  'text-privacy-update': 'Atualização da Política de Privacidade',
  'text-terms-condition': 'Termos e Condições',
  'text-return-policy': 'Política de Devolução',
  'text-top-manufacturer': 'Principais Fabricantes',
  'text-show-products': 'Mostrar Produtos',
  'text-guest-checkout': 'Finalizar Compra como Convidado',
  'text-click-here': 'Clique Aqui',
  'text-previous-step': 'Passo Anterior',
  'text-downloadable': 'Para Download',
  'text-write-review': 'Escrever uma Avaliação',
  'text-product-id': 'ID do Produto',
  'text-give-ratings': 'Dar Avaliações',
  'text-upload-images': 'Enviar Imagens',
  'text-report-abuse': 'Denunciar Abuso',
  'text-product-reviews': 'Avaliações de Produtos',
  'text-page': 'Página',
  'text-pages': 'Páginas',
  'text-ratings-reviews': 'Avaliações & Comentários de',
  'text-ratings': 'avaliações',
  'text-and': 'e',
  'text-reviews': 'comentários',
  'text-question-answers': 'Perguntas e Respostas',
  'text-question-search-placeholder': 'Tem uma pergunta? Busque por respostas.',
  'text-ask-question': 'Faça uma pergunta ao vendedor',
  'text-question-additional-info':
    'Sua pergunta não deve conter informações de contato, como e-mail, telefone ou links externos.',
  'profile-sidebar-my-wishlist': 'Favoritos',
  'text-remove': 'Remover',
  'text-add-all-to-cart': 'Adicionar todos os itens ao carrinho',
  'text-comment': 'Comentário',
  'text-report': 'Denunciar',
  'text-feedback-submitted': 'Feedback Enviado',
  'text-review-request-submitted': 'Avaliação Enviada',
  'text-abuse-report-submitted': 'Relatório de abuso enviado com sucesso',
  'text-question-submitted':
    'Pergunta enviada com sucesso. Aguarde a resposta do vendedor.',
  'text-no-question-found': 'Nenhuma pergunta encontrada',
  'PICKBAZAR_ERROR.ALREADY_ADDED_TO_WISHLIST_FOR_THIS_PRODUCT':
    'Este produto já está nos seus favoritos',
  'text-added-to-wishlist': 'Adicionado com sucesso à seus favoritos!',
  'text-removed-from-wishlist': 'Removido com sucesso dos seus favoritos!',
  'text-sort-by': 'Ordenar Por',
  'text-no-reviews-found': 'Nenhuma avaliação encontrada',
  'text-update-review': 'Atualizar avaliação',
  'PICKBAZAR_MESSAGE.OLD_PASSWORD_INCORRECT': 'Senha antiga está incorreta',
  'PICKBAZAR_MESSAGE.OTP_SEND_SUCCESSFUL': 'OTP enviado com sucesso',
  'PICKBAZAR_MESSAGE.REQUIRED_INFO_MISSING':
    'Informações obrigatórias ausentes',
  'PICKBAZAR_MESSAGE.CONTACT_UPDATE_SUCCESSFUL':
    'Contato atualizado com sucesso',
  'PICKBAZAR_ERROR.INVALID_GATEWAY': 'Gateway inválido',
  'PICKBAZAR_ERROR.CONTACT_UPDATE_FAILED': 'Falha ao atualizar contato',
  'PICKBAZAR_ERROR.ALREADY_REFUNDED': 'Já foi reembolsado',
  'PICKBAZAR_ERROR.ORDER_ALREADY_HAS_REFUND_REQUEST':
    'Pedido já possui solicitação de reembolso',
  'PICKBAZAR_ERROR.REFUND_ONLY_ALLOWED_FOR_MAIN_ORDER':
    'Reembolso permitido apenas para o pedido principal',
  'PICKBAZAR_ERROR.WRONG_REFUND': 'Reembolso incorreto',
  'PICKBAZAR_ERROR.CSV_NOT_FOUND': 'CSV não encontrado',
  'PICKBAZAR_ERROR.ALREADY_GIVEN_REVIEW_FOR_THIS_PRODUCT':
    'Você já deu uma avaliação para este produto',
  'PICKBAZAR_ERROR.USER_NOT_FOUND': 'Usuário não encontrado',
  'PICKBAZAR_ERROR.TOKEN_NOT_FOUND': 'Token não encontrado',
  'PICKBAZAR_ERROR.INVALID_COUPON_CODE':
    'Código de cupom inválido! Por favor, tente novamente.',
  'PICKBAZAR_ERROR.COUPON_CODE_IS_NOT_APPLICABLE':
    'Desculpe, este cupom não atende ao valor do seu pedido.',
  'PICKBAZAR_ERROR.ALREADY_FREE_SHIPPING_ACTIVATED':
    'Frete grátis já ativado! Por favor, tente novamente.',
  'text-review-request-update-submitted':
    'Solicitação de avaliação atualizada com sucesso',
  'text-place-order-helper-text':
    'Por favor, selecione e preencha todos os campos e finalize seu pedido',
  'text-question': 'Pergunta',
  'text-answer': 'Resposta',
  'text-message': 'Mensagem',
  'profile-sidebar-my-questions': 'Minhas Perguntas',
  'profile-sidebar-my-reports': 'Meus Relatórios',
  'payment-confirmed': 'Pagamento Confirmado! Clique em Finalizar Pedido',
  'text-payment-order':
    'Clique em Finalizar Pedido para realizar o pedido e o pagamento',
  'text-card-expiry': 'Data de Expiração',
  'text-card-cvc': 'CVC',
  'text-payment-title': 'Pague seu pagamento',
  'text-pay': 'Pagar',
  'text-order-status': 'Status do Pedido',
  'text-payment-status': 'Status do Pagamento',
  insufficient_funds: 'Seu cartão possui fundos insuficientes.',
  'order-pending': 'Pedido Pendente',
  'order-processing': 'Pedido em Processamento',
  'order-completed': 'Pedido Concluído',
  'order-cancelled': 'Pedido Cancelado',
  'order-failed': 'Falha no Pedido',
  'order-at-local-facility': 'Pedido na Instalação Local',
  'order-out-for-delivery': 'Pedido em Rota de Entrega',
  'order-refunded': 'Pedido Reembolsado',
  'payment-pending': 'Pagamento Pendente',
  'payment-processing': 'Processando Pagamento',
  'payment-success': 'Pagamento Bem-sucedido',
  'payment-failed': 'Falha no Pagamento',
  'payment-reversal': 'Estorno de Pagamento',
  'payment-wallet': 'Pagamento com Carteira',
  'payment-cash-on-delivery': 'Dinheiro na Entrega',
  'payment-cash': 'Dinheiro',
  'payment-awaiting-for-approval': 'Pagamento Aguardando Aprovação',
  'payment-refunded': 'Pagamento Reembolsado',
  'text-pay-now': 'Pagar Agora',
  'text-stripe-card-desc-title': 'O que você receberá no Stripe',
  'text-stripe-card-desc-one': 'Temos uma política de reembolso de 24 horas.',
  'text-stripe-card-desc-two': 'Cartão de compras ilimitado para E-Commerce.',
  'text-stripe-card-desc-three': 'Sem limite para transações diárias.',
  'text-no-payment-configure': 'Nenhum Pagamento Configurado Ainda!!',
  'profile-sidebar-my-cards': 'Meus Cartões',
  'profile-add-cards': 'Adicionar Cartão',
  'profile-new-cards': 'Novo Cartão',
  'text-paypal': 'Paypal',
  'text-map-cant-load': 'O mapa não pode ser carregado no momento, desculpe.',
  'set-default-card-message': 'Cartão padrão definido com sucesso',
  'card-successfully-deleted': 'Deletado com sucesso',
  'card-successfully-add': 'Cartão adicionado com sucesso',
  'default-btn-text': 'Padrão',
  'text-no-card-found': 'Nenhum cartão encontrado',
  'text-card-owner-name': 'Nome do Proprietário do Cartão',
  'text-card-expire': 'Data de Expiração',
  'text-company': 'Empresa',
  'text-save-card': 'Salvar Cartão',
  'text-add-default-card': 'Adicionar como cartão padrão',
  'text-expire-date-placeholder': 'MM / AA',
  'error-verify-token': 'Erro na verificação do token',
  'email-not-verified': 'Seu e-mail ainda não foi verificado.',
  'email-not-description':
    'Obrigado por se inscrever! Antes de começar, você poderia verificar seu endereço de e-mail clicando no link que acabamos de enviar para você? Se você não recebeu o e-mail, ficaremos felizes em enviar outro.',
  'resend-verification-button-text': 'Reenviar E-mail de Verificação',
  'successfully-email-updated': 'E-mail atualizado com sucesso',
  'payment-successful': 'Pagamento bem-sucedido',
  'payment-not-successful': 'Pagamento não bem-sucedido',
  'something-wrong': 'Algo deu errado',
  'pay-latter': 'Pagar Depois',
  'text-set-as-default': 'Definir como Padrão',
  'text-best-selling': 'Produtos Mais Vendidos',
  'placeholder-search-location': 'Busque a localização aqui',
  'text-location': 'Localização',
  'text-access-denied': 'Acesso Negado',
  'text-access-denied-message':
    'Você não tem permissão para acessar esta página.',
  'text-return-home': 'Voltar para a página inicial',
  'email-send-successfully': 'E-mail enviado com sucesso',
  'error-comment-required': 'Comentário é obrigatório',
  'error-select-rating': 'Selecione pelo menos uma avaliação',
  'error-rating-required': 'Avaliação é obrigatória',
  'text-amount-due': 'Valor Devido',
  'text-available-flash-sale': 'Oferta Relâmpago Disponível',
  percentage: 'Percentual',
  fixed_rate: 'Taxa Fixa',
  'text-title-days': 'dias',
  'text-title-hours': 'horas',
  'text-title-minutes': 'minutos',
  'text-title-seconds': 'segundos',
  'text-title-change-language': 'Alterar Idioma',
  'text-title-language': 'Idioma',
  'text-maintenance-mode-title': 'Modo de Manutenção Começa em',
  'text-offers-title': 'Ofertas',
  'text-already-review': 'Já revisado',
  'successfully-address-deleted': 'Endereço deletado com sucesso',
  'successfully-address-created': 'Endereço criado com sucesso',
  category: 'categoria',
  'categories.name': 'Categoria',
  brand: 'Marca',
  manufacturer: 'Fabricante',
  packaging: 'Apresentação',
  dosage: 'Dosagem',
  active_ingredient: 'Princípio ativo',
  active_ingredients: 'Ingrediente ativo',
  is_controlled: 'Medicamento controlado',
  requires_prescription: 'Requer receita',
  is_antibiotic: 'Antibiótico',
  'text-notification-not-found': 'Sem notificações 🧐',
  'text-notification-read-message': 'Notificação lida com sucesso.',
  'text-notifications-read-message':
    'Todas as notificações foram marcadas como lidas.',
  'text-news': 'Novidades',
  'heading-grocery': 'Mantimentos Entregues em 90 Minutos',
  'subheading-grocery':
    'Receba seus alimentos saudáveis e lanches entregues em sua casa todos os dias',
  'heading-bakery': 'Receba seus Itens de Padaria',
  'subheading-bakery':
    'Receba seus itens favoritos de padaria assados e entregues em sua casa a qualquer momento',
  'heading-makeup': 'Maquiagens Importadas e de Marca',
  'subheading-makeup':
    'A maneira mais fácil e barata de receber suas maquiagens importadas e de marca',
  'heading-bags': 'Bolsas Exclusivas de Marca',
  'subheading-bags': 'Receba suas bolsas exclusivas e de marca rapidamente',
  'heading-clothing': 'Compre seus Vestidos de Grife',
  'subheading-clothing':
    'Vestidos prontos para usar, feitos sob medida para você. Aproveite enquanto durarem os estoques.',
  'heading-furniture': 'Móveis Exclusivos a Preço Baixo',
  'subheading-furniture':
    'Transforme sua casa em um lar com nossa ampla coleção de móveis lindos',
  'promotion-slide-one': 'Economia com Cupons',
  'promotion-slide-two': 'Entrega Grátis',
  'promotion-slide-three': 'Vale-Presente',
  'promotion-slide-four': 'Pagamento na Entrega',
  'promotion-slide-five': 'Entrega Expressa',
  'terms-text-home': 'Início',
  'terms-main-title': 'Termos e Condições',
  'terms-one-title': 'Objetivo',
  'terms-one-description':
    '<p>A Little &amp; Big está comprometida em proteger sua privacidade porque valorizamos as pessoas. Nossa Política de Privacidade abaixo define como suas informações pessoais são coletadas, usadas e protegidas. Os&nbsp;<a href="http://demo.dummy">Princípios de Privacidade do País de Demonstração</a>&nbsp;também se aplicam a nós.</p><p>Esta Política de Privacidade descreve nossas políticas e procedimentos sobre a coleta, manutenção, uso e divulgação de suas informações pessoais e deve ser lida juntamente com nossos&nbsp;Termos e Condições. Ao fornecer suas informações pessoais, você consente com a nossa coleta, uso e divulgação dessas informações de acordo com esta Política de Privacidade.</p>',
  'terms-two-title': 'O que são Dados Pessoais?',
  'terms-two-description':
    '<p>Quando usado nesta Política, "informações pessoais" tem o significado dado na Lei de Privacidade. Em geral, significa qualquer informação ou opinião que possa ser usada para identificar você.</p>',
  'terms-three-title': 'Dados Pessoais Coletados',
  'terms-three-description':
    '<p>Dados Pessoais coletados para os seguintes fins e usando os seguintes serviços:</p><ol><li>Google Analytics: Cookies; Dados de Uso</li><li>Formulário de contato: endereço de e-mail; primeiro nome; número de telefone</li><li>Lista de e-mails ou newsletter: endereço de e-mail; primeiro nome</li></ol>',
  'terms-four-title': 'Acesso aos seus Dados Pessoais',
  'terms-four-description':
    '<p>Você pode solicitar acesso às suas informações pessoais coletadas por nós e pedir que corrijamos essas informações pessoais. Você pode solicitar acesso ou correção entrando em contato conosco e geralmente responderemos dentro de 30 dias. Se recusarmos o acesso ou a correção de suas informações pessoais, notificaremos você por escrito com as razões.</p>',
  'terms-five-title': 'Reclamações',
  'terms-five-description':
    '<p>Se você acreditar que sua privacidade foi violada ou tiver uma reclamação sobre como lidamos com suas informações pessoais, por favor, entre em contato conosco por escrito. Responderemos dentro de um período razoável (geralmente dentro de 30 dias).</p>',
  'terms-six-title': 'Proprietário e Controlador de Dados',
  'terms-six-description':
    '<p>The Commons</p><p>20-40 demo St,</p><p>Jon doe NSW 2008</p><p>País</p><p>demo@demo.com</p>',
  'policy-main-title': 'Política de Privacidade',
  'policy-one-title': 'Objetivo',
  'policy-one-description':
    '<p>A Little &amp; Big está comprometida em proteger sua privacidade porque valorizamos as pessoas. Nossa Política de Privacidade abaixo define como suas informações pessoais são coletadas, usadas e protegidas. Os&nbsp;<a href="http://demo.dummy">Princípios de Privacidade do País de Demonstração</a>&nbsp;também se aplicam a nós.</p><p>Esta Política de Privacidade descreve nossas políticas e procedimentos sobre a coleta, manutenção, uso e divulgação de suas informações pessoais e deve ser lida juntamente com nossos&nbsp;Termos e Condições. Ao fornecer suas informações pessoais, você consente com a nossa coleta, uso e divulgação dessas informações de acordo com esta Política de Privacidade.</p>',
  'policy-two-title': 'O que é Dados Pessoais?',
  'policy-two-description':
    '<p>Quando usado nesta Política, "informações pessoais" tem o significado dado na Lei de Privacidade. Em geral, significa qualquer informação ou opinião que possa ser usada para identificar você.</p>',
  'policy-three-title': 'Dados Pessoais Coletados',
  'policy-three-description':
    '<p>Dados Pessoais coletados para os seguintes fins e usando os seguintes serviços:</p><ol><li>Google Analytics: Cookies; Dados de Uso</li><li>Formulário de contato: endereço de e-mail; primeiro nome; número de telefone</li><li>Lista de e-mails ou newsletter: endereço de e-mail; primeiro nome</li></ol>',
  'policy-four-title': 'Acesso aos seus Dados Pessoais',
  'policy-four-description':
    '<p>Você pode solicitar acesso às suas informações pessoais coletadas por nós e pedir que corrijamos essas informações pessoais. Você pode solicitar acesso ou correção entrando em contato conosco e geralmente responderemos dentro de 30 dias. Se recusarmos o acesso ou a correção de suas informações pessoais, notificaremos você por escrito com as razões.</p>',
  'policy-five-title': 'Reclamações',
  'policy-five-description':
    '<p>Se você acreditar que sua privacidade foi violada ou tiver uma reclamação sobre como lidamos com suas informações pessoais, por favor, entre em contato conosco por escrito. Responderemos dentro de um período razoável (geralmente dentro de 30 dias).</p>',
  'policy-six-title': 'Proprietário e Controlador de Dados',
  'policy-six-description':
    '<p>The Commons</p><p>20-40 demo St,</p><p>Jon doe NSW 2008</p><p>País</p><p>demo@demo.com</p>',
  'faq-one-title': 'Como entrar em contato com o Atendimento ao Cliente?',
  'faq-one-content':
    'Nossa Equipe de Experiência do Cliente está disponível 7 dias por semana e oferecemos 2 formas de contato: E-mail e Chat. Tentamos responder rapidamente, para que você não precise esperar muito por uma resposta!',
  'faq-two-title':
    'Instalação do app falhou, como atualizar as informações do sistema?',
  'faq-two-content':
    'Leia a documentação com atenção. Também temos alguns tutoriais em vídeo online sobre esse problema. Se o problema persistir, por favor, abra um chamado no fórum de suporte.',
  'faq-three-title': 'O site está demorando para responder, como melhorar?',
  'faq-three-content':
    'Primeiro, verifique sua conexão com a internet. Também temos alguns tutoriais em vídeo online sobre esse problema. Se o problema persistir, por favor, abra um chamado no fórum de suporte.',
  'faq-four-title': 'Como criar uma conta?',
  'faq-four-content':
    'Se você deseja abrir uma conta para uso pessoal, pode fazê-lo pelo telefone ou online. Abrir uma conta online deve levar apenas alguns minutos.',
  'pbm-activation-title': 'Complete sua adesão ao programa',
  'pbm-activation-subtitle': 'Preencha seus dados para liberar o desconto.',
  'pbm-activation-subtitle-program':
    'Preencha seus dados para liberar o desconto de {program}.',
  'pbm-activation-step': 'Tentativa {n} de 3',
  'pbm-activation-submit': 'Continuar e verificar desconto',
  'pbm-activation-submitting': 'Enviando adesão…',
  'pbm-activation-lgpd-link': 'termos e condições de privacidade',
  'pbm-activation-lgpd-checkbox':
    'Li e aceito os termos e condições de privacidade do programa',
  'pbm-activation-lgpd-required': 'É necessário aceitar o termo para continuar',
  'coupon-picker-title': 'Cupons',
  'coupon-picker-description':
    'Escolha um cupom para este pedido ou digite um código.',
  'coupon-picker-available': 'Disponíveis para você',
  'coupon-picker-locked': 'Indisponíveis no momento',
  'coupon-picker-empty':
    'Nenhum cupom disponível para este carrinho. Tem um código? Digite acima.',
  'coupon-best-option': 'Melhor opção',
  'coupon-apply': 'Aplicar',
  'coupon-applied': 'Aplicado',
  'coupon-applying': 'Aplicando…',
  'coupon-swap': 'Trocar',
  'coupon-remove': 'Remover',
  'coupon-view-all': 'Ver todos os cupons ({n})',
  'coupon-view-locked': 'Ver cupons ({n})',
  'coupon-save': 'Economize {amount}',
  'coupon-you-save': 'Você economiza {amount}',
  'coupon-save-unknown': 'Escolha a entrega para ver a economia',
  'coupon-no-extra-savings': 'Sem economia extra com a forma de pagamento atual',
  'coupon-expires-in-hours': 'Expira em {n}h',
  'coupon-expires-in-minutes': 'Expira em {n} min',
  'coupon-valid-until': 'Válido até {date}',
  'coupon-rules': 'Regras',
  'coupon-rules-hide': 'Ocultar regras',
  'coupon-add-more': 'Adicione mais {amount} para usar',
  'coupon-value-fixed': '{amount} OFF',
  'coupon-value-percentage': '{n}% OFF',
  'coupon-value-free-shipping': 'Frete grátis',
  'coupon-source-roulette': 'Prêmio da roleta',
  'coupon-source-bulk': 'Código exclusivo',
  'coupon-source-granted': 'Liberado para você',
  'coupon-source-email_list': 'Seu e-mail',
  'coupon-source-indication': 'Indicação',
  'coupon-source-public': 'Oferta da loja',
};
/** Lookup by translation key; returns key if missing. */
export function ptBr(key: string): string {
  return ptBrMessages[key] ?? key;
}

/** Dynamic API / error keys (e.g. PICKBAZAR_ERROR.*) resolved against common strings. */
export function ptBrCommon(key: string | undefined): string {
  if (!key) return '';
  const normalized = key.startsWith('common:')
    ? key.slice('common:'.length)
    : key;
  return ptBrMessages[normalized] ?? ptBrMessages[key] ?? key;
}
